import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { defineComponent } from "vue";
import titleUrl from "@/assets/img/pc/homePage/video-title.png";
import { useRouter } from "vue-router";
// components
import VideoList from "@/components/pc/common/video-list.vue";
import PreviewDialog from "@/components/common/preview-dialog.vue";
import moreUrl from "@/assets/img/pc/homePage/more-btn.png";
import { useRaceVideo } from "@/hooks/race-video";
export default defineComponent({
  name: "VideoPc",
  setup() {
    const {
      videoState,
      clickVideoItemFct
    } = useRaceVideo(8);
    const router = useRouter();
    const toRaceVideo = () => {
      router.push("/race-video");
    };
    return () => {
      return _createVNode("div", {
        "class": "content pc-information"
      }, [_createVNode("div", {
        "class": "title-box",
        "id": "selection-video"
      }, [_createVNode("img", {
        "class": "title",
        "src": titleUrl
      }, null)]), _createVNode("div", {
        "class": "more-btn",
        "onClick": toRaceVideo
      }, [_createVNode("img", {
        "class": "more-btn-img",
        "src": moreUrl
      }, null)]), videoState.total ? _createVNode(VideoList, {
        "class": "video-list",
        "videoData": videoState.videoData,
        "colSpan": 6,
        "onClickVideoItem": itemVal => clickVideoItemFct(itemVal)
      }, null) : _createVNode("div", {
        "class": "not-finished"
      }, [_createTextVNode("\u656C\u8BF7\u671F\u5F85\xB7\xB7\xB7\xB7")]), _createVNode(PreviewDialog, {
        "visible": videoState.showPreview,
        "onUpdate:visible": $event => videoState.showPreview = $event
      }, {
        default: () => [_createVNode("div", {
          "class": "video-erea"
        }, [_createVNode("video", {
          "autoplay": true,
          "muted": true,
          "controls": true
        }, [_createVNode("source", {
          "src": videoState.curVideoItem.url || videoState.curVideoItem.resource
        }, null), _createVNode("p", null, [_createTextVNode("Your browser does not support the video tag.")])])])]
      })]);
    };
  }
});